<template>
  <modal
    elem-id="modal_billing_360"
    :title="modalTitle"
    :show="isVisible"
    size="xlarge"
    :close-label="t('Fechar')"
    close-test-id="billing-360-modal-close"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible && franquiaId">
      <div data-testid="billing-360-modal">
        <BillingThreeSixtyDetail :franquia-id="franquiaId" :is-staff="isStaff" :initial-tab="initialTab" />
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import Modal from '../../../ui/Modal.vue'
import BillingThreeSixtyDetail from './BillingThreeSixtyDetail.vue'

const { t } = useI18n()

const isVisible = ref(false)
const franquiaId = ref<number | null>(null)
const franchiseName = ref<string>('')
const isStaff = ref<boolean>(true)
const initialTab = ref<string | number | undefined>(undefined)

const modalTitle = computed(() => {
  if (franchiseName.value) {
    return `${t('Billing 360')} — ${franchiseName.value}`
  }
  if (franquiaId.value) {
    return `${t('Billing 360')} — #${franquiaId.value}`
  }
  return t('Billing 360')
})

function handleOpen(payload?: { franquiaId?: number; franchiseName?: string; isStaff?: boolean; initialTab?: string | number }): void {
  const id = Number(payload?.franquiaId)
  if (!id) {
    log('BillingThreeSixtyModal', 'handleOpen', 'open ignored — missing franquiaId', payload)
    return
  }
  franquiaId.value = id
  franchiseName.value = payload?.franchiseName ?? ''
  isStaff.value = payload?.isStaff !== false
  initialTab.value = payload?.initialTab
  isVisible.value = true
  log('BillingThreeSixtyModal', 'handleOpen', 'Opening billing 360', { franquiaId: id, isStaff: isStaff.value, initialTab: initialTab.value })
}

function closeModal(): void {
  isVisible.value = false
  franquiaId.value = null
  franchiseName.value = ''
  isStaff.value = true
  initialTab.value = undefined
}



onMounted(() => {
  eventBus.on('modal.billing-360.open', handleOpen)
})

onBeforeUnmount(() => {
  eventBus.off('modal.billing-360.open', handleOpen)
})
</script>
